module.exports = __webpack_public_path__ + "img/sample_btn.fed5b5d7.png";